// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99')
];

export const server_loads = [];

export const dictionary = {
		"/": [10],
		"/(app)/billing/credits/return": [12,[2],[3]],
		"/(app)/blog": [13,[2],[3]],
		"/(app)/blog/[id]": [14,[2],[3]],
		"/(app)/calendar": [15,[2],[3]],
		"/(app)/chat": [16,[2],[3]],
		"/(app)/clients": [17,[2],[3]],
		"/(app)/clients/tags": [19,[2],[3]],
		"/(app)/clients/[id]": [18,[2],[3]],
		"/(app)/dashboard": [20,[2],[3]],
		"/(app)/deals": [21,[2],[3]],
		"/(app)/deals/[id]": [22,[2],[3]],
		"/(app)/demands": [23,[2],[3]],
		"/(app)/demands/[id]": [24,[2],[3]],
		"/(app)/documents": [25,[2],[3]],
		"/(app)/documents/trash": [26,[2],[3]],
		"/(auth)/forgot-password": [80,[5]],
		"/(app)/franchise": [27,[2],[3]],
		"/(public)/import": [90,[8]],
		"/(app)/integrations": [28,[2],[3]],
		"/(app)/integrations/import": [30,[2],[3]],
		"/(app)/integrations/portals": [31,[2],[3]],
		"/(app)/integrations/[id]": [29,[2],[3]],
		"/(auth)/invite": [81,[5]],
		"/(auth)/invite/[token]": [82,[5]],
		"/(app)/leads": [32,[2],[3]],
		"/(app)/leads/[id]": [33,[2],[3]],
		"/(auth)/login": [83,[5]],
		"/(app)/lustrace": [34,[2],[3]],
		"/(app)/messages": [35,[2],[3]],
		"/(site)/o/[orgSlug]": [92,[9]],
		"/(site)/o/[orgSlug]/blog": [93,[9]],
		"/(site)/o/[orgSlug]/blog/[slug]": [94,[9]],
		"/(site)/o/[orgSlug]/kontakt": [95,[9]],
		"/(site)/o/[orgSlug]/makler/[slug]": [96,[9]],
		"/(site)/o/[orgSlug]/nemovitost/[slug]": [97,[9]],
		"/(site)/o/[orgSlug]/poptavka": [98,[9]],
		"/(site)/o/[orgSlug]/tym": [99,[9]],
		"/(portal)/portal": [86,[6]],
		"/(portal)/portal/invite": [87,[6]],
		"/(portal)/portal/login": [88,[6]],
		"/(portal)/portal/organizations": [89,[6]],
		"/(app)/projects": [36,[2],[3]],
		"/(app)/projects/[id]": [37,[2],[3]],
		"/(app)/properties": [38,[2],[3]],
		"/(app)/properties/[id]": [39,[2],[3]],
		"/(app)/properties/[id]/edit": [40,[2],[3]],
		"/(app)/reports": [41,[2],[3]],
		"/(auth)/reset-password": [84,[5]],
		"/(app)/settings": [42,[2,4],[3]],
		"/(app)/settings/audit": [43,[2,4],[3]],
		"/(app)/settings/automation": [44,[2,4],[3]],
		"/(app)/settings/automation/runs/[id]": [46,[2,4],[3]],
		"/(app)/settings/automation/[id]": [45,[2,4],[3]],
		"/(app)/settings/billing": [47,[2,4],[3]],
		"/(app)/settings/gdpr": [48,[2,4],[3]],
		"/(app)/settings/integrations": [49,[2,4],[3]],
		"/(app)/settings/integrations/imports": [52,[2,4],[3]],
		"/(app)/settings/integrations/import": [51,[2,4],[3]],
		"/(app)/settings/integrations/lookups": [53,[2,4],[3]],
		"/(app)/settings/integrations/marketing": [54,[2,4],[3]],
		"/(app)/settings/integrations/messaging": [55,[2,4],[3]],
		"/(app)/settings/integrations/personal": [56,[2,4],[3]],
		"/(app)/settings/integrations/portals": [57,[2,4],[3]],
		"/(app)/settings/integrations/portals/mapping": [58,[2,4],[3]],
		"/(app)/settings/integrations/sync": [59,[2,4],[3]],
		"/(app)/settings/integrations/templates": [60,[2,4],[3]],
		"/(app)/settings/integrations/[id]": [50,[2,4],[3]],
		"/(app)/settings/offices": [62,[2,4],[3]],
		"/(app)/settings/office": [61,[2,4],[3]],
		"/(app)/settings/pipelines": [65,[2,4],[3]],
		"/(app)/settings/pipelines/[id]": [66,[2,4],[3]],
		"/(app)/settings/pipeline": [63,[2,4],[3]],
		"/(app)/settings/pipeline/[id]": [64,[2,4],[3]],
		"/(app)/settings/profile": [67,[2,4],[3]],
		"/(app)/settings/teams": [68,[2,4],[3]],
		"/(app)/settings/users": [69,[2,4],[3]],
		"/(app)/settings/venues": [70,[2,4],[3]],
		"/(public)/share/[token]": [91,[7]],
		"/(app)/signing": [71,[2],[3]],
		"/(auth)/signup": [85,[5]],
		"/(app)/social": [72,[2],[3]],
		"/(app)/tasks": [73,[2],[3]],
		"/(app)/tasks/[id]": [74,[2],[3]],
		"/(app)/templates": [75,[2],[3]],
		"/(app)/templates/new": [78,[2],[3]],
		"/(app)/templates/[slug]": [76,[2],[3]],
		"/(app)/templates/[slug]/edit": [77,[2],[3]],
		"/(app)/viewings": [79,[2],[3]],
		"/(app)/[...path]": [11,[2],[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);